import { render, staticRenderFns } from "./logoRepense.vue?vue&type=template&id=76704116&scoped=true&"
import script from "./logoRepense.vue?vue&type=script&lang=js&"
export * from "./logoRepense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76704116",
  null
  
)

export default component.exports